<!--Translated-->
<template>
  <table class="table--type2 table--defense">
    <colgroup>
      <col class="tbl-cellproblem" />
      <col class="col-add" />
      <col class="tbl-cellproduct" />
      <col class="tbl-cellinpt" />
      <col class="tbl-cellprice" />
      <col v-if="phase.is_temporary && canEdit" class="col-delete" />
    </colgroup>
    <thead>
      <tr>
        <th class="tbl-cellproblem">
          <div class="tbl_info">
            <div class="tbl_info-wrap">
              <div v-svg="{ name: 'stimulator' }"></div>
              <div class="tbl_info-celltext">
                {{ $t('ProgramTypesStimulationsTable:Header') }}
              </div>
            </div>
          </div>
        </th>
        <th class="tbl-cellproduct" colspan="2">
          {{ $t('ProgramTypesStimulationsTable:TableHeaders:0') }}
        </th>
        <th class="tbl-cellinpt">
          {{ $t('ProgramTypesStimulationsTable:TableHeaders:1') }}
        </th>
        <th class="tbl-cellprice">
          {{ $t('ProgramTypesStimulationsTable:TableHeaders:2') }}
        </th>
        <th
          v-if="phase.is_temporary && canEdit"
          class="col-delete unicol-colordark"
        >
          <div v-svg="{ name: 'delete' }"></div>
        </th>
      </tr>
    </thead>
    <template v-if="typesStimulations.length > 0">
      <RowStimulationType
        v-for="sType of typesStimulations"
        :sType="sType"
        :phase="phase"
        :key="sType.id"
        @deleteStimulationType="deleteStimulationType"
      />
    </template>
    <template v-if="virtualTypesStimulations.length > 0">
      <RowStimulationType
        v-for="sType of virtualTypesStimulations"
        :sType="sType"
        :phase="phase"
        :key="sType.id"
      />
    </template>
    <tbody
      v-if="
        typesStimulations.length === 0 && virtualTypesStimulations.length === 0
      "
    >
      <tr class="row tbl_row--active row--message">
        <td class="tbl-cellproblem" :colspan="phase.is_temporary ? 6 : 5">
          <div v-if="phase.is_temporary">
            <div class="cblock__infoblock">
              <p>
                {{
                  $t('ProgramTypesStimulationsTable:AddTypesStimulationText')
                }}
              </p>
              <Button
                v-if="canEdit"
                :text="
                  $t('ProgramTypesStimulationsTable:AddTypesStimulationButton')
                "
                size="standart"
                color="accentlines"
                icon="plus"
                @click="$emit('addStimulationType', phase.id)"
              />
            </div>
          </div>
          <div v-else>
            {{ $t('ProgramTypesStimulationsTable:NoText') }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapState } from 'vuex';
import { mutationTypes } from '@/store/modules/programs';
import Button from '@/components/views/Button';
import RowStimulationType from './ProgramRowStimulationType';

export default {
  name: 'ProgramTypesStimulationsTable',
  components: {
    Button,
    RowStimulationType,
  },
  props: { phase: { type: Object, required: true } },
  computed: {
    ...mapState({
      canEdit: (state) =>
        state.auth.currentUserRole?.claim_plants_care_add === 1,
      typesStimulations(state) {
        const fromVisibleCombos =
          state.programs.programTypesStimulationCombinations
            .filter((c) => c.program_phase_id === this.phase.id)
            .filter((combo) => {
              const comboProducts =
                state.programs.programTypesStimulationCombinationsProducts
                  .filter((p) => p.combination_id === combo.id)
                  .map((p) =>
                    state.plantsCare.products?.find(
                      ({ id }) => id === p.product_id
                    )
                  )
                  .filter(Boolean);
              const hasInactiveProduct = comboProducts.some(
                (product) => product.is_active === 0
              );
              if (!hasInactiveProduct) return true;
              return Boolean(
                combo.is_selected ||
                  state.programs.serverData.programTypesStimulationCombinations?.find(
                    ({ id }) => id === combo.id
                  )?.is_selected
              );
            })
            .map((c) => c.type_stimulation_id);
        const fromProducts = state.programs.programTypesStimulationProducts
          .filter(({ program_phase_id }) => this.phase.id === program_phase_id)
          .map(({ type_stimulation_id }) => type_stimulation_id);
        return [...new Set([...fromProducts, ...fromVisibleCombos])]
          .map((tsId) =>
            state.programs.typesStimulation.find(({ id }) => id === tsId)
          )
          .filter(Boolean);
      },
      virtualTypesStimulations(state) {
        return state.programs.programPhasesTypesStimulation
          .filter(
            ({ program_phase_id, type_stimulation_id }) =>
              this.phase.id === program_phase_id &&
              !this.typesStimulations.some(
                ({ id }) => id === type_stimulation_id
              )
          )
          .map(({ type_stimulation_id }) =>
            state.programs.typesStimulation.find(
              ({ id }) => id === type_stimulation_id
            )
          );
      },
    }),
  },
  methods: {
    deleteStimulationType(id) {
      this.$confirm({
        message: this.$t(
          'ProgramTypesStimulationsTable:ConfirmDeleteModal:Message'
        ),
        buttons: {
          left: {
            text: this.$t(
              'ProgramTypesStimulationsTable:ConfirmDeleteModal:ButtonLeft'
            ),
            icon: 'delete',
          },
          right: {
            text: this.$t(
              'ProgramTypesStimulationsTable:ConfirmDeleteModal:ButtonRight'
            ),
            icon: 'cancel',
          },
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.commit(mutationTypes.removeStimulationType, {
              id,
              phaseId: this.phase.id,
            });
          }
        },
      });
    },
  },
};
</script>
